import React, { useEffect, useRef, useState } from "react";

import { CopyToClipboard } from "react-copy-to-clipboard";
import NumberFormat from "react-number-format";

import { CarTransmission, CarFuel, renderNumberGreaterThan100, PromoModes } from "../../common/common";


import { MessageBox } from "../../common/messagebox";
import { commonErr } from "../../common/errors";
import FavoriteButton from "../../common/favoritebutton";

import { TooltipH } from "../../components/tooltip";

import CarMapLocation from "./carmaplocation";
import MapBox from "./mapbox"

import five_star_polish from "../../../static/images/svg/five-star-polish.svg";

import {
	IcStarRating,
	IcTotalTrip,
	IcShareLink,
	SeatCar,
	FuelCar,
	FuelCCar,
	TransCar,
	IcInformation,
	IcInfoOrangeM,
	IcInfoBlackM,
	IcPromoCarOrange,
	IcPromoCarGreen,
	IcChevrRightS,
	IcMapRoute,
	IcChevronRight,
	IcMarkerMap
} from "../../common/svg";

export const InfoCar = ({ info, isSD, showLoginForm, isLogged, favWD, stype }) => {
	const [copied, setCopied] = useState(false);

	const toggleCopyBox = () => {
		setCopied(!copied);
	};

	return (
		<div className="info-car-basic">
			<div className="group-name">
				<h3>{info.name}</h3>
				<div className="group-action d-flex-center-btw">
					<div className="shared">
						<CopyToClipboard text={window.location.href} onCopy={toggleCopyBox}>
							<div className="wrap-svg wrap-ic share">
								<IcShareLink />
							</div>
						</CopyToClipboard>
						<FavoriteButton
							icon={false}
							car={info}
							showLoginForm={showLoginForm}
							isLogged={isLogged}
							stype={stype}
							favWD={favWD}
						/>
					</div>
				</div>
			</div>

			<div className="group-total">
				{info.totalTrips > 0 ? (
					<>
						<div className="wrap-svg">
							<IcStarRating />
						</div>
						<span className="info">{info.rating.avg.toFixed(1)}</span>
						<span className="dot">•</span>
						<div className="wrap-svg">
							<IcTotalTrip />
						</div>
						<span className="info">{renderNumberGreaterThan100(info.totalTrips)} chuyến</span>
					</>
				) : (
					<span className="info">Chưa có chuyến</span>
				)}
				<span className="dot">•</span>
				<span className="info">{info.locationAddr}</span>
			</div>
			{isSD ? (
				<div className="group-tag">
					<span className={`tag-item ${info.optionsTransmission === 1 ? "transmission" : "delivery"}`}>
						{CarTransmission[info.optionsTransmission]}
					</span>
					{info.deliveryEnable === 1 && info.deliveryPrice > 0 && (
						<span className="tag-item non-mortgage">Giao xe tận nơi</span>
					)}
					{info.deliveryEnable === 1 && info.deliveryPrice === 0 && (
						<span className="tag-item non-mortgage">Miễn phí giao xe</span>
					)}
					{info.instant === 1 && <span className="tag-item instant">Đặt xe nhanh</span>}
					{info.nonMortgage === 1 && <span className="tag-item non-mortgage">Miễn thế chấp</span>}
				</div>
			) : (
				<div className="group-tag">
					{info.wdShort && info.wdShort.instant === 1 && <span className="tag-item instant">Đặt xe nhanh</span>}
				</div>
			)}

			<MessageBox error={commonErr.SUCCESS} show={copied} hideModal={toggleCopyBox} message="Đã sao chép liên kết" />
		</div>
	);
};

export const OutsFeatures = ({ info }) => {
	return (
		<div className="info-car-desc" id="outsfeatures">
			<h6>Đặc điểm</h6>
			<div className="outstanding-features">
				<div className="outstanding-features__item">
					<div className="wrap-svg">
						<SeatCar />
					</div>
					<div className="title">
						<p className="sub">Số ghế</p>
						<p className="main">{info.seat} chỗ</p>
					</div>
				</div>
				<div className="outstanding-features__item">
					<div className="wrap-svg">
						<TransCar />
					</div>
					<div className="title">
						<p className="sub">Truyền động</p>
						<p className="main">{CarTransmission[info.optionsTransmission]}</p>
					</div>
				</div>
				<div className="outstanding-features__item">
					<div className="wrap-svg">
						<FuelCar />
					</div>
					<div className="title">
						<p className="sub">Nhiên liệu</p>
						<p className="main">{CarFuel[info.optionsFuel]}</p>
					</div>
				</div>
				{info.optionsFuelConsumption > 0 && (
					<div className="outstanding-features__item">
						<div className="wrap-svg">
							<FuelCCar />
						</div>
						<div className="title">
							<p className="sub">NL tiêu hao</p>
							<p className="main">
								{info.optionsFuelConsumption} {info.optionsFuel == 3 ? "km /lần sạc" : "lít/100km"}
							</p>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export const Features = ({ info }) => {
	return (
		<>
			{info.features && info.features.length > 0 && (
				<div className="info-car-desc">
					<h6>Các tiện nghi khác</h6>
					<div className="features-car">
						<ul>
							{info.features.map((feature, i) => (
								<li key={i}>
									{" "}
									<img loading="lazy" src={feature.logo} alt="Mioto - Thuê xe tự lái" /> {feature.name}
								</li>
							))}
						</ul>
					</div>
				</div>
			)}
		</>
	);
};

export const Description = ({ info }) => {
	const [isShowMoreText, setIsShowMoreText] = useState(false);
	const descriptionRef = useRef(0);
	const heightDescription = descriptionRef.current ? descriptionRef.current.clientHeight : 0;
	const heightMaximum = heightDescription < 168;

	const onReadMore = () => {
		setIsShowMoreText(true);
	};
	return (
		<>
			{info && info !== "" && info.desc && (
				<div className="info-car-desc">
					<h6>Mô tả</h6>
					<pre ref={descriptionRef} className={`${isShowMoreText || heightMaximum ? "" : "hide"}`}>
						{info.desc}
					</pre>
					{!isShowMoreText && !heightMaximum && (
						<p className="read-more" onClick={onReadMore}>
							Xem thêm
						</p>
					)}
				</div>
			)}
		</>
	);
};

export const Papers = ({ trip, info }) => {
	const requiredPapers = info.requiredPapers ? info.requiredPapers : info;

	const tooltDesc = () => {
		return (
			<>
				<b>Bạn đã có CCCD gắn chip </b>
				<br />
				Giấy tờ thuê xe gồm có: <br />- Giấy phép lái xe &amp; CCCD (chủ xe đối chiếu và gửi lại bạn) <br />
				<b>Bạn chưa có CCCD gắn chip </b>
				<br />
				Giấy tờ thuê xe gồm có: <br />- Giấy phép lái xe (chủ xe đối chiếu và gửi lại bạn) <br />- Passport (chủ xe đối
				chiếu, giữ lại và hoàn trả khi bạn trả xe) <br />
				Lưu ý: Khách thuê vui lòng chuẩn bị đầy đủ BẢN GỐC tất cả giấy tờ thuê xe khi làm thủ tục nhận xe.
			</>
		);
	};

	return (
		<>
			{requiredPapers && (
				<div className={`${trip ? "desc-car" : "info-car-desc"}`} id="papers">
					<TooltipH title={"Giấy tờ thuê xe"} position={"top"} sizeContent={"M"} desc={tooltDesc} />
			
					<div className="required-papers">
						<div className="required-papers__item">
							{requiredPapers.length > 1 ? (
								<div className="type__item">
									<div className="wrap-svg">
										<IcInfoBlackM />
									</div>
									<p className="font-12">Chọn 1 trong 2 hình thức</p>
								</div>
							) : null}
							{requiredPapers
								.filter((paper) => paper.conditionOr === 1)
								.map((paper) => (
									<div key={paper.id} className="type-content">
										<img loading="lazy" src={paper.logo} />
										<div className="type-name">
											<p>{paper.name}</p>
										</div>
									</div>
								))}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export const Mortgates = ({ trip, info }) => {
	const tooltDesc = () => {
		if (info.nonMortgage) {
			return (
				<>
					Chủ xe hỗ trợ chính sách <strong>miễn thế chấp.</strong> Khách hàng không cần để lại tài sản (xe máy hoặc 15tr
					tiền mặt) khi thuê xe của chủ xe.
					<br />
					Các phụ phí phát sinh (nếu có) trong quá trình thuê xe, khách hàng vui lòng thanh toán trực tiếp cho chủ xe
					khi làm thủ tục trả xe.
				</>
			);
		} else {
			return (
				<>
					Bạn sẽ để lại tài sản thế chấp (tiền mặt/chuyển khoản hoặc xe máy kèm cà vẹt gốc) cho chủ xe khi làm thủ tục
					nhận xe <br />
					Chủ xe sẽ gửi lại tài sản thế chấp khi bạn hoàn trả xe theo như nguyên trạng ban đầu lúc nhận xe
				</>
			);
		}
	};
	return (
		<>
			{info.mortgages && info.mortgages.length > 0 && (
				<div className={trip ? "desc-car" : "info-car-desc"}>
					<TooltipH title={"Tài sản thế chấp"} position={"top"} sizeContent={"M"} desc={tooltDesc} />
					<div className="required-papers">
						{info.mortgages.map((mortgage) => (
							<p key={mortgage.id}>{mortgage.name}</p>
						))}
					</div>
				</div>
			)}
		</>
	);
};

export const Policy = ({ trip, policies }) => {
	const [isShowMoreText, setIsShowMoreText] = useState(false);
	const policyRef = useRef(0);
	const heightPolicy = policyRef.current ? policyRef.current.clientHeight : 0;
	const heightMaximum = heightPolicy < 168;

	const onReadMore = () => {
		setIsShowMoreText(true);
	};
	return (
		<>
			{policies && policies !== "" && (
				<div className={trip ? "desc-car" : "info-car-desc"}>
					<h6>Điều khoản</h6>
					<pre ref={policyRef} className={`${isShowMoreText || heightMaximum ? "" : "hide"}`}>
						{policies}
					</pre>
					{!isShowMoreText && !heightMaximum && (
						<p className="read-more" onClick={onReadMore}>
							Xem thêm
						</p>
					)}
				</div>
			)}
		</>
	);
};

export const Owner = ({ ownerProfile, isSD }) => {
	const onProfileUrl = () => {
		const state = {
			isOwner: true,
			isTrip: false,
			isReview: false,
		};
		// window.history.pushState(state, '', `/profile/${ownerProfile.uid}`)
		localStorage.setItem("info", JSON.stringify(state));
	};

	return (
		<div className="info-car-desc" id="owner">
			<h6>Chủ xe</h6>
			<div className="profile-info">
				<a href={`/profile/${ownerProfile.uid}`} onClick={onProfileUrl} className="profile-desc">
					<div className={`avatar avatar--m`}>
						<img
							loading="lazy"
							src={ownerProfile.avatar && ownerProfile.avatar.thumbUrl ? ownerProfile.avatar.thumbUrl : avatar_default}
						/>
					</div>

					<div className="info">
						<h5>{ownerProfile.name}</h5>
						<div className="verifi">
							{ownerProfile.owner.totalTrips > 0 ? (
								<>
									<div className="wrap-svg">
										<IcStarRating />
									</div>
									<p className="info">{ownerProfile.owner.rating.avg.toFixed(1)}</p>
									<p className="dot">•</p>
									<div className="wrap-svg">
										<IcTotalTrip />
									</div>
									<p className="info">{renderNumberGreaterThan100(ownerProfile.owner.totalTrips)} chuyến</p>
								</>
							) : (
								<p className="info">Chưa có chuyến</p>
							)}
						</div>
					</div>
				</a>

				<div className="owner-response">
					<div className="response-desc">
						<p className="title">Tỉ lệ phản hồi</p>
						<p className="rate">{ownerProfile.owner.responseRate}</p>
					</div>
					<div className="response-desc">
						<p className="title">Thời gian phản hồi</p>
						<p className="rate">{ownerProfile.owner.responseTime}</p>
					</div>
					<div className="response-desc">
						<p className="title">Tỉ lệ đồng ý</p>
						<p className="rate">{ownerProfile.owner.acceptRate}</p>
					</div>
				</div>
			</div>
			{((isSD && ownerProfile.owner.ownerHostFiveStarSD > 0) ||
				(!isSD && ownerProfile.owner.ownerHostFiveStarWD > 0)) && (
				<div className="five-star-info">
					<img loading="lazy" src={five_star_polish} alt="Chủ xe 5*" />
					<p>
						Chủ xe 5* có thời gian phản hồi nhanh chóng, tỉ lệ đồng ý cao, mức giá cạnh tranh & dịch vụ nhận được nhiều
						đánh giá tốt từ khách&nbsp;hàng.
					</p>
				</div>
			)}
		</div>
	);
};

export const CarMap = ({ info, showMapBox, openMapBox, closeMapBox}) => {
	return (
		<div className="info-car-desc" id="carmap">
			<h6>Vị trí xe</h6>
			<div className="car-address">
				<div className="address"> 
					<div className="wrap-svg">
						<IcMarkerMap />
					</div>
					<p>{info.locationAddr}</p>
				</div>
				<div className="maps-detail" style={{cursor: 'pointer'}} onClick={openMapBox}> 
					<div className="wrap-svg"> 
						<IcMapRoute />
					</div>
					<p className="font-14 fontWeight-7">Xem bản đồ</p>
					<div className="wrap-svg"> 
						<IcChevronRight />
					</div>
				</div>
			</div>
			<p className="note-address">Địa chỉ cụ thể sẽ được hiển thị sau khi đặt cọc</p>
			{/* <CarMapLocation location={info.location} /> */}
			<MapBox show={showMapBox} onHide={closeMapBox} location={info.location} title={"Bản đồ vị trí xe"} />
		</div>
	);
};

export const Surcharge = ({ info, trip, tripD }) => {
	const [isShowMoreText, setIsShowMoreText] = useState(false);
	const surchargeRef = useRef(0);
	const heightSurcharge = surchargeRef.current ? surchargeRef.current.clientHeight : 0;
	const heightMaximum = heightSurcharge < 120;

	const onReadMore = () => {
		setIsShowMoreText(true);
	};

	const isShowLimitEnable = tripD ? trip.limitEnable === 1 : info.limitEnable === 1;
	const isShowOverTimePriceEnable = info.additionalPrice && info.additionalPrice.overTimePriceEnable === 1;
	const isShowWashingPriceEnable = info.additionalPrice && info.additionalPrice.washingPriceEnable === 1;
	const isShowDeodorisePriceEnable = info.additionalPrice && info.additionalPrice.deodorisePriceEnable === 1;

	const isShowSurcharge =
		isShowLimitEnable || isShowOverTimePriceEnable || isShowWashingPriceEnable || isShowDeodorisePriceEnable;

	return (
		<>
			{isShowSurcharge ? (
				<div className="surcharge">
					<p className="title text-primary">Phụ phí có thể phát sinh</p>
					<div ref={surchargeRef} className={`surcharge-container ${isShowMoreText || heightMaximum ? "" : "hide"}`}>
						{info.limitEnable === 1 || (tripD && trip.limitEnable === 1) ? (
							<div className="surcharge-item">
								<div className="wrap-svg">
									<IcInformation />
								</div>
								<div className="content">
									<div className="content-item">
										<p className="title">Phí vượt giới hạn</p>
										<p className="cost">
											<NumberFormat
												value={tripD ? trip.limitPrice : info.limitPrice}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ/km"}
											/>
										</p>
									</div>
									{/* <div className="content-item">
									<p className="sub-title">Giới hạn quãng đường</p>
									<p className="sub-title">{info.limitKM}km/ngày</p>
								</div> */}
									<div className="content-item">
										<p>
											Phụ phí phát sinh nếu lộ trình di chuyển vượt quá{" "}
											<span>
												{tripD ? trip.priceSummary.totalDays * trip.limitKM : info.totalDays * info.limitKM}km
											</span>{" "}
											khi thuê xe
											<span> {tripD ? trip.priceSummary.totalDays : info.totalDays} ngày</span>
										</p>
									</div>
								</div>
							</div>
						) : (
							<div className="surcharge-item">
								<div className="wrap-svg">
									<IcInformation />
								</div>
								<div className="content">
									<div className="content-item">
										<p className="title">Phí vượt giới hạn</p>
										<p className="cost">
											<span>Không tính phí</span>
										</p>
									</div>
								</div>
							</div>
						)}
						{info.additionalPrice && info.additionalPrice.overTimePriceEnable === 1 && (
							<div className="surcharge-item">
								<div className="wrap-svg">
									<IcInformation />
								</div>
								<div className="content">
									<div className="content-item">
										<p className="title">Phí quá giờ</p>
										<p className="cost">
											<NumberFormat
												value={info.additionalPrice.overTimePrice}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ/h"}
											/>
										</p>
									</div>
									<div className="content-item">
										<p>
											Phụ phí phát sinh nếu hoàn trả xe trễ giờ. Trường hợp trễ quá
											<span> {info.additionalPrice.maxHoursOvertime} tiếng</span>, phụ phí thêm <span>1 ngày </span>
											thuê
										</p>
									</div>
								</div>
							</div>
						)}
						{info.additionalPrice && info.additionalPrice.washingPriceEnable === 1 && (
							<div className="surcharge-item">
								<div className="wrap-svg">
									<IcInformation />
								</div>
								<div className="content">
									<div className="content-item">
										<p className="title">Phí vệ sinh</p>
										<p className="cost">
											<NumberFormat
												value={info.additionalPrice.washingPrice}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ"}
											/>
										</p>
									</div>
									<div className="content-item">
										<p>Phụ phí phát sinh khi xe hoàn trả không đảm bảo vệ sinh (nhiều vết bẩn, bùn cát, sình lầy...)</p>
									</div>
								</div>
							</div>
						)}
						{info.additionalPrice && info.additionalPrice.deodorisePriceEnable === 1 && (
							<div className="surcharge-item">
								<div className="wrap-svg">
									<IcInformation />
								</div>
								<div className="content">
									<div className="content-item">
										<p className="title">Phí khử mùi</p>
										<p className="cost">
											<NumberFormat
												value={info.additionalPrice.deodorisePrice}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ"}
											/>
										</p>
									</div>
									<div className="content-item">
										<p>Phụ phí phát sinh khi xe hoàn trả bị ám mùi khó chịu (mùi thuốc lá, thực phẩm nặng mùi...)</p>
									</div>
								</div>
							</div>
						)}
						{info.optionsFuel === 3 && info.additionalPrice?.batteryChargingPriceEnable === 1 && (
							<div className="surcharge-item">
								<div className="wrap-svg">
									<IcInformation />
								</div>
								<div className="content">
									<div className="content-item">
										<p className="title">Phí sạc pin</p>
										<p className="cost">
											<NumberFormat
												value={info.additionalPrice.batteryChargingPrice}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ/km"}
											/>
										</p>
									</div>
									<div className="content-item">
										<p>Khách thuê thanh toán phí sạc pin theo số KM di chuyển</p>
									</div>
								</div>
							</div>
						)}
					</div>
					{!isShowMoreText && !heightMaximum && (
						<p className="read-more" onClick={onReadMore}>
							Xem thêm
						</p>
					)}
				</div>
			) : null}
		</>
	);
};

export const Promotion = ({ priceSummary, isSD, openPromoBox, removePromoCode, promoCode, priceMode, car }) => {
	const [promoMode, setPromoMode] = useState(PromoModes.DEFAULT);

	useEffect(() => {
		if (promoCode) {
			setPromoMode(PromoModes.CODE);
		} else {
			setPromoMode(PromoModes.DEFAULT);
		}
	}, [promoMode, promoCode]);

	const handlePromoModeChange = (e) => {
		setPromoMode(+e.target.value);
		if (+e.target.value === PromoModes.CODE) {
			openPromoBox();
		} else if (+e.target.value === PromoModes.DEFAULT) {
			removePromoCode();
		}
	};

	const renderPromotion = () => {
		const priceOrigin = isSD
			? priceMode === 2
				? priceSummary?.priceOriginWithFee
				: priceSummary?.priceOrigin
			: priceMode === 2
			? priceSummary?.totalPriceOriginWithFee
			: priceSummary?.totalPriceOrigin;

		const priceSpecial = isSD
			? priceMode === 2
				? priceSummary?.priceSpecialWithFee
				: priceSummary?.priceSpecial
			: priceMode === 2
			? priceSummary?.specialPriceTotalWithFee
			: priceSummary?.specialPriceTotal;

		const specialDiscount = isSD ? priceSummary?.specialDiscount : priceSummary?.specialDiscountTotal;
		const discountPercent = isSD ? priceSummary?.discountPercent : priceSummary?.ownerDiscountPercent;

		const discountPromo = isSD
			? priceMode === 2
				? (priceSummary?.priceOriginWithFee - priceSummary?.priceSpecialWithFee) * priceSummary?.totalDays
				: (priceSummary?.priceOrigin - priceSummary?.priceSpecial) * priceSummary?.totalDays
			: priceSummary?.specialDiscountTotal;

		const promotionDiscount = isSD ? priceSummary?.promotionDiscount : priceSummary?.promotionDiscountTotal;

		if (car) {
			if (!priceSummary?.specialDiscountDesc && priceOrigin === priceSpecial) {
				//case 1: discount: not discount
				return (
					<>
						<div className="line-page" />
						<div className="promotion-radio">
							<div className="promotion-radio__item">
								<div className="custom-radio">
									{promoCode ? (
										<div className="promotion-inner">
											<div className="promo-text">
												<div className="promo-text-main">
													<div className="wrap-svg">
														<IcPromoCarGreen />
													</div>
													<p>
														Mã <span className="fontWeight-6">{promoCode}</span>
													</p>
													<div className="close pointer" onClick={removePromoCode}>
														×
													</div>
												</div>
											</div>
											{promotionDiscount > 0 && (
												<p className="promo-price">
													-
													<NumberFormat
														value={promotionDiscount}
														displayType={"text"}
														thousandSeparator={" "}
														decimalSeparator={","}
														suffix={"đ"}
													/>
												</p>
											)}
										</div>
									) : (
										<div className="promotion-inner pointer" onClick={openPromoBox}>
											<div className="promo-text">
												<div className="promo-text-main">
													<div className="wrap-svg">
														<IcPromoCarGreen />
													</div>
													<p>Mã khuyến mãi</p>
												</div>
											</div>
											<div className="promo-price">
												<div className="wrap-svg">
													<IcChevrRightS />
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</>
				);
			} else if (specialDiscount >= 0 && discountPercent === 0 && priceOrigin >= priceSpecial) {
				//case 2: discount with day
				return (
					<>
						<div className="line-page" />
						<div className="promotion-radio">
							<div className="promotion-radio__item">
								<div className="custom-radio">
									<input
										type="radio"
										id="default"
										name="promo"
										value={PromoModes.DEFAULT}
										checked={promoMode === PromoModes.DEFAULT}
										onChange={(e) => handlePromoModeChange(e)}
									/>
									<label htmlFor="default">
										<div className="promo-text">
											<div className="promo-text-main">
												<div className="wrap-svg">
													<IcPromoCarOrange />
												</div>
												<p>Chương trình giảm giá</p>
											</div>
											<p className="promo-text-sub">{priceSummary.specialDiscountDesc}</p>
										</div>
										{discountPromo > 0 && (
											<p className="promo-price">
												-
												<NumberFormat
													value={discountPromo}
													displayType={"text"}
													thousandSeparator={" "}
													decimalSeparator={","}
													suffix={"đ"}
												/>
											</p>
										)}
									</label>
								</div>
							</div>
							<div className="promotion-radio__item">
								<div className="custom-radio">
									<input
										type="radio"
										id="code"
										name="promo"
										value={PromoModes.CODE}
										checked={promoMode === PromoModes.CODE}
										onChange={(e) => handlePromoModeChange(e)}
									/>
									{promoCode ? (
										<label htmlFor="code">
											<div className="promo-text">
												<div className="promo-text-main">
													<div className="wrap-svg">
														<IcPromoCarGreen />
													</div>
													<p>
														Mã <span className="fontWeight-6">{promoCode}</span>
													</p>
													<div
														className="close"
														onClick={(e) => {
															removePromoCode();
															e.preventDefault();
														}}>
														×
													</div>
												</div>
											</div>
											{promotionDiscount > 0 && (
												<p className="promo-price">
													-
													<NumberFormat
														value={promotionDiscount}
														displayType={"text"}
														thousandSeparator={" "}
														decimalSeparator={","}
														suffix={"đ"}
													/>
												</p>
											)}
										</label>
									) : (
										<label htmlFor="code">
											<div className="promo-text">
												<div className="promo-text-main">
													<div className="wrap-svg">
														<IcPromoCarGreen />
													</div>
													<p>Mã khuyến mãi</p>
												</div>
											</div>
											<div className="promo-price">
												<div className="wrap-svg">
													<IcChevrRightS />
												</div>
											</div>
										</label>
									)}
								</div>
							</div>
						</div>
					</>
				);
			} else {
				// case 3: discount with week, month
				return (
					<>
						<div className="line-page" />
						<div className="promotion-radio">
							<div className="promotion-radio__item">
								<div className="custom-radio">
									<div className="promotion-inner">
										<div className="promo-text">
											<div className="promo-text-main">
												<div className="wrap-svg">
													<IcPromoCarOrange />
												</div>
												<p>Chương trình giảm giá</p>
											</div>
											<p className="promo-text-sub">{priceSummary.specialDiscountDesc}</p>
										</div>
										{discountPromo > 0 && (
											<p className="promo-price">
												-
												<NumberFormat
													value={discountPromo}
													displayType={"text"}
													thousandSeparator={" "}
													decimalSeparator={","}
													suffix={"đ"}
												/>
											</p>
										)}
									</div>
								</div>
							</div>
							<div className="promotion-radio__item">
								<div className="custom-radio">
									{promoCode ? (
										<div className="promotion-inner">
											<div className="promo-text">
												<div className="promo-text-main">
													<div className="wrap-svg">
														<IcPromoCarGreen />
													</div>
													<p>
														Mã <span className="fontWeight-6">{promoCode}</span>
													</p>
													<div className="close pointer" onClick={removePromoCode}>
														×
													</div>
												</div>
											</div>
											{promotionDiscount > 0 && (
												<p className="promo-price">
													-
													<NumberFormat
														value={promotionDiscount}
														displayType={"text"}
														thousandSeparator={" "}
														decimalSeparator={","}
														suffix={"đ"}
													/>
												</p>
											)}
										</div>
									) : (
										<div className="promotion-inner pointer" onClick={openPromoBox}>
											<div className="promo-text">
												<div className="promo-text-main">
													<div className="wrap-svg">
														<IcPromoCarGreen />
													</div>
													<p>Mã khuyến mãi</p>
												</div>
											</div>
											<div className="promo-price">
												<div className="wrap-svg">
													<IcChevrRightS />
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</>
				);
			}
		} else {
			return (
				<>
					{(discountPromo > 0 || promotionDiscount > 0) && (
						<>
							<div className="line-page" />
							<div className="promotion-radio">
								{discountPromo > 0 && (
									<div className="promotion-radio__item">
										<div className="custom-radio">
											<div className="promotion-inner">
												<div className="promo-text">
													<div className="promo-text-main">
														<div className="wrap-svg">
															<IcPromoCarOrange />
														</div>
														<p>Chương trình giảm giá</p>
													</div>
													<p className="promo-text-sub">{priceSummary.specialDiscountDesc}</p>
												</div>
												<p className="promo-price">
													-
													<NumberFormat
														value={discountPromo}
														displayType={"text"}
														thousandSeparator={" "}
														decimalSeparator={","}
														suffix={"đ"}
													/>
												</p>
											</div>
										</div>
									</div>
								)}
								{promotionDiscount > 0 && (
									<div className="promotion-radio__item">
										<div className="custom-radio">
											<div className="promotion-inner">
												<div className="promo-text">
													<div className="promo-text-main">
														<div className="wrap-svg">
															<IcPromoCarGreen />
														</div>
														<p>
															Mã <span className="fontWeight-6">{promoCode}</span>
														</p>
													</div>
												</div>
												<p className="promo-price">
													-
													<NumberFormat
														value={promotionDiscount}
														displayType={"text"}
														thousandSeparator={" "}
														decimalSeparator={","}
														suffix={"đ"}
													/>
												</p>
											</div>
										</div>
									</div>
								)}
							</div>
						</>
					)}
				</>
			);
		}
	};

	return renderPromotion();
};

